<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="商品名" label-width="80px">
        <el-input v-model="searchForm.name" placeholder="商品名" clearable> </el-input>
      </el-form-item>
      <!-- <el-form-item label="品牌" label-width="100">
        <el-select v-model="searchForm.brandId" filterable placeholder="选择品牌">
          <el-option
            v-for="(item, index) in supList"
            :key="index"
            :label="item.name"
            clearable
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
     <!-- <el-form-item label="商品类型" label-width="80px">
        <el-cascader
          placeholder="选择分类"
          :options="typeList"
          v-model="classifyId"
          :props="{
            checkStrictly: true,
            value: 'id',
            label: 'name',
            children: 'children',
          }"
          @change="onSelectPMenu"
          ref="cateData"
          clearable
          filterable
        ></el-cascader>
      </el-form-item> -->
      <el-form-item>
        <el-button @click="getStoreGoods(1)" type="success">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="getod()" type="success">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addUpdateGoodsButton('', '')"
          >添加商品</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button type="danger" plain size="mini" @click="delHandle(null)"
          >批量删除
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
    >
      <el-table-column type="selection" width="70" align="center" />
      <el-table-column  width="200" align="center" label="商品封面" prop="storeGoodsCover">
        <template slot-scope="scope">
          <el-image
            style="width: 70px; height: 70px"
            :src="scope.row.cover"
            fit="scale-down"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品名称"
        prop="name"
      ></el-table-column>
	  <el-table-column prop="awardName" align="center" label="收益规则" width="200">
	  </el-table-column>
      <!-- <el-table-column
        width="260"
        align="center"
        label="品牌"
        prop="name"
      ></el-table-column> -->
     <!-- <el-table-column width="148" align="center" label="商品分类">
        <template slot-scope="scope">
          {{ scope.row.classifyName }}
        </template>
      </el-table-column> -->
      <el-table-column
        width="140"
        align="center"
        label="商品原价"
        prop="originalPrice"
      ></el-table-column>
      <el-table-column
         width="140"
        align="center"
        label="商品价格"
        prop="price"
      ></el-table-column>

      <el-table-column
        width="140"
        align="center"
        label="商品销量"
        prop="salesVolume"
      ></el-table-column>
      <el-table-column
        width="140"
        align="center"
        label="起订数量"
        prop="startBuy"
      ></el-table-column>
     <!-- <el-table-column
        width="150"
        align="center"
        label="商品参数"
        prop="parameters"
      ></el-table-column> -->
      <el-table-column width="300" align="center" label="操作" prop="icon" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="success"
            plain
            slot="reference"
            @click="updStoreGoodsIsOnframe(scope.row)"
          >
            上架
          </el-button>
          <el-button
            type="success"
            plain
            slot="reference"
            v-if="scope.row.isOnframe == 0"
            @click="updStoreGoodsIsRecommend(scope.row)"
          >
            {{ scope.row.isRecommend == "1" ? "取消推荐" : "设置推荐" }}
          </el-button>
          <el-button type="primary" plain @click="addUpdateGoodsButton(scope.row, 1)"
            >编辑</el-button
          >
          <!-- <el-button type="primary" plain @click="addUpdateGoodsButton(scope.row,'')">复制添加</el-button> -->
          <el-button
            v-if="scope.row.isOnframe != 0"
            type="danger"
            plain
            slot="reference"
            @click="delHandle(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>
    <el-dialog
      title="订单详情"
      :visible.sync="smvisible"
      width="1000px"
      append-to-body
      :close-on-click-modal="false"
      class="dialogClass"
    >
      <div class="flexcen">
        <div class="titcon">商品名称</div>
        <div class="cus_html">
          {{ shopinfo.storeGoodsName }}
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">配送类型</div>
        <div class="cus_html">
          {{ shopinfo.deliveryType == 1 ? "自提" : "配送" }}
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">规格</div>
        <div class="cus_html">
          <div v-for="(i, o) in shopinfo.tcommoditySpecifications" :key="o">
            规格名：{{ i.specifications || "" }} ，规格价{{ i.specificationsPrice || 0 }}
          </div>
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品状态</div>
        <div class="cus_html">
          {{ shopinfo.isOnframe == "0" ? "下架" : "上架" }}
        </div>
      </div>

      <div class="flexcen">
        <div class="titcon">简介</div>
        <div class="cus_html">
          {{ shopinfo.discountExplain }}
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">单位</div>
        <div class="cus_html">
          {{ shopinfo.unit }}
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品类型</div>
        <div class="cus_html">
          {{ shopinfo.typeName }}
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">供应商</div>
        <div class="cus_html">
          {{ shopinfo.supplierName }}
        </div>
      </div>

      <div class="flexcen">
        <div class="titcon">规格</div>
        <div class="cus_html">
          {{ shopinfo.storeGoodWeight }}
        </div>
      </div>
	 
	  
      <div class="flexcen">
        <div class="titcon">成本价</div>
        <div class="cus_html">￥{{ shopinfo.storeGoodsOriginalPrice }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">价格</div>
        <div class="cus_html">￥{{ shopinfo.storeGoodsPrice }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">库存</div>
        <div class="cus_html">
          {{ shopinfo.residueCartons }}
        </div>
      </div>
      <div style="height: 20px"></div>
      <div class="issline"></div>
      <div style="height: 20px"></div>
      <div class="flexcen">
        <div class="titcon">封面</div>
        <div class="cus_html">
          <img class="stimg" :src="shopinfo.storeGoodsCover" alt="" />
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品轮播</div>
        <div class="cus_html">
          <img
            class="stimg"
            v-for="(item, index) in shopinfo.slideshow"
            :key="index"
            :src="item"
            alt=""
          />
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品详情</div>
        <div class="cus_html">
          <img
            class="stimg"
            :src="item"
            v-for="(item, index) in shopinfo.bannerCover"
            :key="index"
            alt=""
          />
        </div>
      </div>
    </el-dialog>
    <div v-if="dialog">
      <Sing ref="addUpdateSingProduct" @refreshDataList="getStoreGoods"></Sing>
    </div>
    <BalancePayment
      ref="balancePayment"
      v-if="balancePaymentVisble"
      @refreshDataList="getStoreGoods"
    >
    </BalancePayment>
    <AddParameter
      ref="getParameter"
      v-if="getParametervisible"
      @refreshDataList="getStoreGoods"
    ></AddParameter>
  </div>
</template>

<script>
import Sing from "./components/SingProduct";
import BalancePayment from "./BalancePayment";
import AddParameter from "./AddParameter";
export default {
  name: "SingProduct",
  components: {
    Sing,
    BalancePayment,
    AddParameter,
  },
  data() {
    return {
      smvisible: false,
      dalong: false,
      sortVisible: false,
      boxItemsVisible: false,
      nonQueuingVisible: false,
      getParametervisible: false,
      dialog: false,
      gardenNames: "",
      shopinfo: "",
      loading: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        classifyFirstId: "",
      },
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      GardenIdList: [],
      typeList: [],
      total: 0,
      size: 10,
      current: 1,
      addUpdateSingProductVisible: false,
      updateGoodssVisible: false,
      balancePaymentVisble: false,
      ids: [],
      classifyId: [],
      supList: [],
    };
  },
  created() {
    this.getStoreGoods();

    this.getTypeList();
    this.supp();
  },
  methods: {
    onSelectPMenu(val) {
      console.log("777");
    },
    supp() {
      this.$axios.get("/admin/brand/getBrandListNoPage").then((res) => {
        this.supList = res.data;
      });
    },
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      console.log("7777", this.ids);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    lookinfo(e) {
      this.$axios
        .post("/sysCommodityManagement/getProductDetails", {
          id: e.storeGoodsId,
        })
        .then((res) => {
          this.smvisible = true;
          this.shopinfo = res.data;
          this.shopinfo.slideshow = this.shopinfo.slideshow.split(",");
          this.shopinfo.bannerCover = this.shopinfo.bannerCover.split(",");
        });
    },
    getod() {
      this.searchForm = {
        name: "",
        storeGoodsType: "",
        brandId: "",
        classifyFirstId: "",
        classifyId: "",
      };
      this.classifyId = [];
      this.getStoreGoods(1);
    },
    sort(id) {
      this.sortVisible = true;
      this.$nextTick(() => {
        this.$refs.sort.init(id);
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // handleSelectionChange(val) {
    // 	this.multipleSelection = val;
    // 	this.delBtlStatu = val.length == 0
    // },

    handleSizeChange(val) {
      this.size = val;
      this.getStoreGoods();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getStoreGoods();
    },
    addUpdateParameterButton(model) {
      this.getParametervisible = true;
      this.$nextTick(() => {
        this.$refs.getParameter.init(model.storeGoodsCartonsId, model.storeGoodsId);
      });
    },
    //获取园区列表
    // getGardenList(name) {
    // 	this.$axios.post("/admin/singleStoreGoods/getGardenList", {
    // 		name: ''
    // 	}).then(res => {
    // 		this.GardenIdList = res.data;
    // 	})
    // },
    getTypeList() {
      this.$axios.get("/admin/commodityClassify/getAllLevelList").then((res) => {
        this.typeList = res.data;
      });
    },
    getStoreGoods(current) {
      if (this.classifyId.length > 0) {
        this.searchForm.classifyFirstId = this.classifyId[0];
        if (this.classifyId.length > 1) {
          this.typeList.map((item) => {
            item.children.map((itrs) => {
              if (this.classifyId[1] == itrs.id) {
                this.searchForm.classifyId = itrs.uid;
              }
            });
          });
        } else {
          this.searchForm.classifyId = "";
        }
      } else {
        this.searchForm.classifyId = "";
        this.searchForm.classifyFirstId = "";
      }

      if (current) {
        this.current = current;
      }

      this.loading = true;
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/commodity/getLowerCommodityList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.current;
          this.total = res.data.total;
          this.loading = false;
        });
    },

    // 根据id删除数据
    removeById(id) {},

    delHandle(id) {
      var arr = [];
      var txtsd = "";
      if (id) {
        arr.push(id);
        txtsd = "此操作将删除该商品，是否继续?";
      } else {
        if (this.ids.length > 0) {
          arr = this.ids;
          txtsd = "此操作将删除选中商品，是否继续?";
        } else {
          return;
        }
      }
      this.$confirm(txtsd, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/commodity/deleteCommodity", {
            idList: arr,
          })
          .then((res) => {
            this.getStoreGoods();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    //  addUpdateGoodsButton(id){
    //     this.addUpdateSingProductVisible=true;
    //     this.$nextTick(()=>{
    //         this.$refs.addUpdateSingProduct.init(id);
    //     })
    // },
    addUpdateGoodsButton(model, d) {
      if (model != null) {
        this.dialog = true;
        this.$nextTick(() => {
          this.$refs.addUpdateSingProduct.init(model.id, d);
        });
      } else {
        this.dialog = true;
        this.$nextTick(() => {
          this.$refs.addUpdateSingProduct.init();
        });
      }
      console.log(model);
    },

    //下架、上架商城商品
    updStoreGoodsIsOnframe(model) {
      var that = this;
      var txt = "";
      // if(model){
      // 	that.ids = []
      // 	that.ids.push(model.id)
      // }else{
      // 	if(that.ids.length>0){
      // 		txt=that.ids.length+'份'
      // 	}else{
      // 		that.$message({
      // 			showClose: true,
      // 			message: '请选择商品',
      // 			type: 'info',
      // 			onClose: () => {

      // 			}
      // 		});
      // 		return
      // 	}

      // }

      this.$confirm("操作需谨慎：此操作是将该商品上架，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$axios
          .post("/admin/commodity/upperCommodity", {
            id: model.id,
          })
          .then((res) => {
            that.getStoreGoods();
            that.$message({
              showClose: true,
              message: res.msg,
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    //设置是否轮播
    updStoreGoodsIsRotation(id) {
      this.$axios
        .post("/admin/singleStoreGoods/updSingleStoreGoodsIsRotation", {
          storeGoodsId: id,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
            onClose: () => {
              this.getStoreGoods();
            },
          });
        });
    },
    balancePayment(id) {
      this.balancePaymentVisble = true;
      this.$nextTick(() => {
        this.$refs.balancePayment.init(id);
      });
    },
    //设置推荐商城商品
    updStoreGoodsIsRecommend(model) {
      this.$confirm(
        "此操作将是该商品" +
          (model.isRecommend === 0 ? "取消推荐" : "推荐商品") +
          "，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios
          .post("/sysCommodityManagement/setProductRecommendations", {
            id: model.storeGoodsId,
          })
          .then((res) => {
            this.getStoreGoods();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    updStoreGoodsStatus(id) {
      this.updStoreGoodsStatusvisible = true;
      this.$nextTick(() => {
        this.$refs.updStoreGoodsStatus.init(id);
      });
    },
    nonQueuing(id) {
      console.log("id", id);
      this.nonQueuingVisible = true;
      this.$nextTick(() => {
        this.$refs.nonQueuing.init(id);
      });
    },
    viewInventory(id) {
      this.boxItemsVisible = true;
      this.$nextTick(() => {
        this.$refs.boxItems.init(id);
      });
    },
    boxRuleButton(id) {
      this.boxRuleVisible = true;
      this.$nextTick(() => {
        this.$refs.boxRule.init(id);
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 30px;
  font-size: 10px;
  margin-right: 10px;
  margin-top: 5px;
}

.titcon {
  width: 150px;
}

.flexcen {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.issline {
  height: 1px;
  background: #e1e1e1;
  width: 100%;
}

.stimg {
  width: 50px;
  height: 50px;
  border-radius: 6rpx;
  display: inline-block;
  margin-right: 10rpx;
}

.mb8 {
  margin-bottom: 10px;
}
.cus_html{
	width: calc(100% - 150px);
}
</style>
